import Container from "../components/Container";
import Image from "../components/Image";
import Text from "../components/Text";
import Person from "../assets/images/person.png";

export default function ComparatorPage() {
    return (
        <Container flexColumn center fullWidth className="flex justify-end items-center">
            <Container className="flex justify-center items-center">
                <Image
                    width={300}
                    src={Person} 
                />
            </Container>

            <Text className="text-center text-4xl font-semibold">
                EM BREVE
            </Text>
        </Container>
    )
}